import { Component,ViewChild } from '@angular/core';
import { NavController,ViewController,NavParams,Platform } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage';
import { provider } from '../../../providers/provider';
import { Slides } from 'ionic-angular';
import { ProductsHorizontalPage } from '../productsHorizontal/productsHorizontal';
import { ProductsNoImageListPage } from '../productsNoImageList/productsNoImageList';
import { productDetailPage } from '../../productDetail/productDetail';
import { CartPage } from '../../cart/cart';
import { CustomizerProvider } from '../../../providers/customizer/customizer';

@Component({
  selector: 'page-products-vertical',
  templateUrl: 'productsVertical.html'
})
export class ProductsVerticalPage {
  @ViewChild(Slides) slides: Slides;
  url: any;
  groupId = '';
  groupContentId = '';
  viewType = 'no-list-image';
  groupContent: any;
  data: any;
  tot = 0;
  width: any;
  height: any;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public translateService: TranslateService,
              public storage: Storage,
              public viewCtrl: ViewController,
              public provider: provider,
              public customizer: CustomizerProvider,
              public platform: Platform) {
    this.url = provider.getUrl();
    this.data = provider.getMenu();
    let group = navParams.get('group');
    this.groupId = group._id;
    this.groupContentId = group.content._id;
    this.groupContent = group.content;

    platform.ready().then((readySource) => {
      this.width = platform.width();
      this.height = platform.height();
    });
  }

  getIngredients(obj) {
    let varIngr=[],ingredients=[];
    for(let j=0; j<obj.content.varIngr.length; j++) {
      for(let i=0; i<this.data.lib.length; i++) {
        if(this.data.lib[i]._id == obj.content.varIngr[j]) {
          varIngr.push(JSON.parse(JSON.stringify(this.data.lib[i])));
        }
      }
    }
    for(let j=0; j<varIngr.length;j++) {
      ingredients.push(`
      <p padding-horizontal text-center text-lowercase>
        <span [ngClass]="{allergene:${obj.content.extraProps.allergene}}" *ngIf="!last">{{provider.renderDescr(${varIngr[j]})}} | </span>
        <span [ngClass]="{allergene:${obj.content.extraProps.allergene}}" *ngIf="last">{{provider.renderDescr(${varIngr[j]})}}</span>
      </p>
      `)
    }
    return ingredients
  }

  getUrlImage(img) {
    return this.url + img + '?w=' + this.width
  }

  showProducts(group) {
    if(group.viewType == 'vertical') 
      this.navCtrl.push(ProductsVerticalPage, { group: group });
    else if(group.viewType == 'horizontal') 
      this.navCtrl.push(ProductsHorizontalPage, { group: group });
    else
      this.navCtrl.push(ProductsNoImageListPage, { group: group });
  }
  showProduct(product) {
    this.navCtrl.push(productDetailPage, { product: product });
  }
  cart() {
    this.navCtrl.push(CartPage);
  }

  ionViewDidEnter() {
    this.tot = this.provider.showTotal();
  }

  ionViewDidLoad() {
    this.data.menu.righe.sort(function(a, b){
      return a.ordering-b.ordering
    });
  }

  // modalità sfoglia menu con scroll

  getImg(img) {
    return 'assets/ALLERGENI/' + img + '.png';
  }

  // check for extended description
  hasExtendedDescription(group) : Boolean {
    return (group.descrizioneEstesa != undefined && group.descrizioneEstesa[0] != undefined && group.descrizioneEstesa[0].contenuto != '');
  }

}




// WEBPACK FOOTER //
// ./src/pages/products/productsVertical/productsVertical.ts